import React from "react";
import { FileText, Calendar, CheckCircle } from "lucide-react";

const IndentDetails = ({ row }) => {
  if (!row) {
    return (
      <div className="text-center text-gray-500 p-4">
        No indent details available
      </div>
    );
  }

  // Ensure all displayed values are strings and handle potential undefined values
  const displayData = {
    indentId: String(row.IndentID || ""),
    status: String(row.Status || ""),
    creationDate: String(row.CreationDate || ""),
    projectName: String(row.ProjectName || ""),
    typeName: String(row.TypeName || ""),
    taskSchedule: String(row.TaskSchedule || ""),
  };

  return (
    <div className="container mx-auto p-4 bg-white shadow-lg rounded-lg">
      <div className="grid grid-cols-2 gap-4">
        <div className="bg-gray-50 p-3 rounded-lg">
          <h2 className="text-xl font-semibold mb-2 text-gray-700 border-b pb-1">
            <FileText className="inline-block mr-1 text-blue-500" size={20} />
            Indent #{displayData.indentId}
          </h2>
          <p
            className={`flex justify-between text-l ${
              displayData.status === "Draft"
                ? "text-yellow-600"
                : displayData.status === "Completed"
                ? "text-green-600"
                : "text-gray-600"
            }`}
          >
            <span className="font-medium text-gray-600">Status:</span>
            <span>{displayData.status}</span>
          </p>
          <p className="flex justify-between text-l">
            <span className="font-medium text-gray-600">Creation Date:</span>
            <span>{displayData.creationDate}</span>
          </p>
        </div>

        <div className="bg-gray-50 p-3 rounded-lg">
          <h2 className="text-xl font-semibold mb-2 text-gray-700 border-b pb-1">
            <CheckCircle className="inline-block mr-1 text-green-500" size={20} />
            Project Information
          </h2>
          <p className="flex justify-between text-l">
            <span className="font-medium text-gray-600">Project Name:</span>
            <span>{displayData.projectName}</span>
          </p>
          <p className="flex justify-between text-l mt-1">
            <span className="font-medium text-gray-600">Invoicing Type:</span>
            <span>{displayData.typeName}</span>
          </p>
          <p className="flex justify-between text-l">
            <span className="font-medium text-gray-600">Task Schedule:</span>
            <span>{displayData.taskSchedule}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default IndentDetails;